export default {"src":"/_next/static/media/note.0532b8ac.svg","height":64,"width":75,"blurWidth":0,"blurHeight":0};